import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import toastr from "toastr";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCH4Jnn1bGpvC2ZYlh_m4H9g26HSCcCO4I",
  authDomain: "handelsonwheels.firebaseapp.com",
  projectId: "handelsonwheels",
  storageBucket: "handelsonwheels.appspot.com",
  messagingSenderId: "755769736147",
  appId: "1:755769736147:web:97f5823e2012bc572e8d26",
  measurementId: "G-YS9T8KPNB3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-top-center",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "swing",
  showMethod: "slideDown",
  hideMethod: "slideUp",
};

export async function submitInquiry(values) {
  await addDoc(collection(db, "eventInquiries"), {
    ...values,
    createdAt: serverTimestamp(),
    source: "web",
    status: "unprocessed",
  });
}

async function logFailedInquiryAttempt(values, error) {
  try {
    await addDoc(collection(db, "failedInquiryAttempts"), {
      values,
      createdAt: serverTimestamp(),
      clientCreatedAt: new Date().toISOString(),
      source: "web",
      errorCode: error?.code || "",
      errorMessage: error?.message || "Unknown submit failure",
      errorName: error?.name || "",
      userAgent: navigator.userAgent,
      language: navigator.language || "",
      online: typeof navigator.onLine === "boolean" ? navigator.onLine : null,
      connectionType: navigator.connection?.effectiveType || null,
    });
  } catch (loggingError) {
    console.error("Failed to log inquiry submission error:", loggingError);
  }
}

function getInquirySubmitErrorMessage(error) {
  switch (error?.code) {
    case "unavailable":
    case "firestore/unavailable":
      return "We couldn't reach our server. Please check your connection and try again.";
    case "permission-denied":
    case "firestore/permission-denied":
      return "Submission was blocked. Please refresh the page and try again.";
    default:
      return "Couldn't send your inquiry. Please try again.";
  }
}

const bookUs = document.querySelectorAll(".book-us-btn");
const quoteButtons = document.querySelectorAll(".flick-card__btn");
const webInquiry = document.querySelector(".web-inquiry-blur");
const close = document.querySelector("#close");
const inquiryContent = document.querySelector(".web-inquiry");

// -----------------------------
// Data cleaning helpers
// -----------------------------
const toStr = (v) => (v == null ? "" : String(v));

// Trim + collapse internal whitespace (including newlines/tabs) to single spaces
const cleanWhitespace = (v) => toStr(v).replace(/\s+/g, " ").trim();

// Capitalize each word (handles hyphens/apostrophes reasonably)
const titleCase = (v) =>
  cleanWhitespace(v)
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) =>
      word
        .split(/(-|')/g)
        .map((part) =>
          part === "-" || part === "'"
            ? part
            : part
              ? part.charAt(0).toUpperCase() + part.slice(1)
              : part,
        )
        .join(""),
    )
    .join(" ");

const cleanEmail = (v) => cleanWhitespace(v).toLowerCase();

// Keep digits only; store E.164-ish if 10 digits (US) by prefixing +1
const cleanPhone = (v) => {
  const digits = toStr(v).replace(/\D+/g, "");
  if (!digits) return "";
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  // Fallback: best-effort with plus
  return digits.startsWith("+") ? digits : `+${digits}`;
};

const SERVICEABLE_STATE_CODES = new Set(["CA"]);

const cleanStreetAddress = (v) => cleanWhitespace(v);
const cleanCity = (v) => titleCase(v);

const cleanPostal = (v) => {
  const digits = toStr(v).replace(/\D+/g, "");
  if (digits.length >= 9) {
    return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
  }
  if (digits.length >= 5) {
    return digits.slice(0, 5);
  }
  return cleanWhitespace(v).toUpperCase();
};

const cleanState = (v) => {
  const code = cleanWhitespace(v).toUpperCase();
  return SERVICEABLE_STATE_CODES.has(code) ? code : "";
};

const formatSiteAddress = ({ street, city, stateCode, postalCode }) => {
  const line1 = cleanWhitespace(street);
  const cityStateZip = [cleanWhitespace(city), cleanWhitespace(stateCode)]
    .filter(Boolean)
    .join(", ")
    .concat(postalCode ? ` ${cleanWhitespace(postalCode)}` : "")
    .trim();
  return [line1, cityStateZip].filter(Boolean).join(", ");
};

// Single-line notes, trimmed
const cleanNotes = (v) => cleanWhitespace(v);

function initAdvancedFormValidation() {
  const formContainers = document.querySelectorAll("[data-form-validate]");
  const isInvalidSelectValue = (value) =>
    value === "" ||
    value === "disabled" ||
    value === "null" ||
    value === "false";

  formContainers.forEach((formContainer) => {
    const startTime = new Date().getTime();
    const form = formContainer.querySelector("form");
    if (!form) return;

    const validateFields = form.querySelectorAll("[data-validate]");
    const dataSubmit = form.querySelector("[data-submit]");
    if (!dataSubmit) return;

    const realSubmitInput = dataSubmit.querySelector('input[type="submit"]');
    if (!realSubmitInput) return;

    function isSpam() {
      const currentTime = new Date().getTime();
      return currentTime - startTime < 5000;
    }

    validateFields.forEach((fieldGroup) => {
      const select = fieldGroup.querySelector("select");
      if (!select) return;

      const options = select.querySelectorAll("option");
      options.forEach((option) => {
        if (isInvalidSelectValue(option.value)) {
          option.setAttribute("disabled", "disabled");
        }
      });
    });

    function isValid(fieldGroup) {
      const radioCheckGroup = fieldGroup.querySelector(
        "[data-radiocheck-group]",
      );
      if (radioCheckGroup) {
        const inputs = radioCheckGroup.querySelectorAll(
          'input[type="radio"], input[type="checkbox"]',
        );
        const checkedInputs = radioCheckGroup.querySelectorAll("input:checked");
        const min = parseInt(radioCheckGroup.getAttribute("min"), 10) || 1;
        const max =
          parseInt(radioCheckGroup.getAttribute("max"), 10) || inputs.length;
        const checkedCount = checkedInputs.length;

        if (!inputs.length) return false;
        if (inputs[0].type === "radio") return checkedCount >= 1;
        if (inputs.length === 1) return inputs[0].checked;
        return checkedCount >= min && checkedCount <= max;
      }

      const input = fieldGroup.querySelector("input, textarea, select");
      if (!input) return false;

      const tag = input.tagName.toLowerCase();
      const value = input.value.trim();

      if (tag === "select") {
        if (input.required) return !isInvalidSelectValue(value);
        return true;
      }

      if (input.type === "email") {
        if (!value) return !input.required;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(value);
      }

      if (input.type === "number") {
        if (!value) return !input.required;
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return false;

        const minValue = input.getAttribute("min");
        const maxValue = input.getAttribute("max");
        if (minValue !== null && numberValue < Number(minValue)) return false;
        if (maxValue !== null && numberValue > Number(maxValue)) return false;
        return true;
      }

      if (input.required && !value) return false;
      if (!value && !input.required) return true;

      const isTextLike =
        tag === "textarea" ||
        input.type === "text" ||
        input.type === "tel" ||
        input.type === "search" ||
        input.type === "password" ||
        input.type === "url";

      if (isTextLike) {
        const minLengthAttr = input.getAttribute("min");
        const maxLengthAttr = input.getAttribute("max");
        const length = value.length;

        if (minLengthAttr !== null && length < Number(minLengthAttr)) {
          return false;
        }
        if (maxLengthAttr !== null && length > Number(maxLengthAttr)) {
          return false;
        }
      }

      return true;
    }

    function updateFieldStatus(fieldGroup) {
      const radioCheckGroup = fieldGroup.querySelector(
        "[data-radiocheck-group]",
      );
      if (radioCheckGroup) {
        const inputs = radioCheckGroup.querySelectorAll(
          'input[type="radio"], input[type="checkbox"]',
        );
        const checkedInputs = radioCheckGroup.querySelectorAll("input:checked");

        if (checkedInputs.length > 0) {
          fieldGroup.classList.add("is--filled");
        } else {
          fieldGroup.classList.remove("is--filled");
        }

        const valid = isValid(fieldGroup);
        if (valid) {
          fieldGroup.classList.add("is--success");
          fieldGroup.classList.remove("is--error");
          return;
        }

        fieldGroup.classList.remove("is--success");
        const validationStarted = Array.from(inputs).some(
          (input) => input.__validationStarted,
        );
        if (validationStarted) {
          fieldGroup.classList.add("is--error");
        } else {
          fieldGroup.classList.remove("is--error");
        }
        return;
      }

      const input = fieldGroup.querySelector("input, textarea, select");
      if (!input) return;

      const value = input.value.trim();
      if (value) {
        fieldGroup.classList.add("is--filled");
      } else {
        fieldGroup.classList.remove("is--filled");
      }

      const valid = isValid(fieldGroup);
      if (valid) {
        fieldGroup.classList.add("is--success");
        fieldGroup.classList.remove("is--error");
      } else {
        fieldGroup.classList.remove("is--success");
        if (input.__validationStarted) {
          fieldGroup.classList.add("is--error");
        } else {
          fieldGroup.classList.remove("is--error");
        }
      }
    }

    function validateAndStartLiveValidationForAll() {
      let allValid = true;
      let firstInvalidField = null;

      validateFields.forEach((fieldGroup) => {
        const input = fieldGroup.querySelector("input, textarea, select");
        const radioCheckGroup = fieldGroup.querySelector(
          "[data-radiocheck-group]",
        );
        if (!input && !radioCheckGroup) return;

        if (input) input.__validationStarted = true;
        if (radioCheckGroup) {
          radioCheckGroup.__validationStarted = true;
          const inputs = radioCheckGroup.querySelectorAll(
            'input[type="radio"], input[type="checkbox"]',
          );
          inputs.forEach((radioInput) => {
            radioInput.__validationStarted = true;
          });
        }

        updateFieldStatus(fieldGroup);

        if (!isValid(fieldGroup)) {
          allValid = false;
          if (!firstInvalidField) {
            firstInvalidField = input || radioCheckGroup.querySelector("input");
          }
        }
      });

      if (!allValid && firstInvalidField) firstInvalidField.focus();
      return allValid;
    }

    validateFields.forEach((fieldGroup) => {
      const input = fieldGroup.querySelector("input, textarea, select");
      const radioCheckGroup = fieldGroup.querySelector(
        "[data-radiocheck-group]",
      );

      if (radioCheckGroup) {
        const inputs = radioCheckGroup.querySelectorAll(
          'input[type="radio"], input[type="checkbox"]',
        );

        inputs.forEach((groupInput) => {
          groupInput.__validationStarted = false;

          groupInput.addEventListener("change", () => {
            requestAnimationFrame(() => {
              if (!groupInput.__validationStarted) {
                const checkedCount =
                  radioCheckGroup.querySelectorAll("input:checked").length;
                const min =
                  parseInt(radioCheckGroup.getAttribute("min"), 10) || 1;
                if (checkedCount >= min) groupInput.__validationStarted = true;
              }

              if (groupInput.__validationStarted) {
                updateFieldStatus(fieldGroup);
              }
            });
          });

          groupInput.addEventListener("blur", () => {
            groupInput.__validationStarted = true;
            updateFieldStatus(fieldGroup);
          });
        });
        return;
      }

      if (!input) return;
      input.__validationStarted = false;

      if (input.tagName.toLowerCase() === "select") {
        input.addEventListener("change", () => {
          input.__validationStarted = true;
          updateFieldStatus(fieldGroup);
        });
        return;
      }

      input.addEventListener("input", () => {
        if (!input.__validationStarted && input.value.trim() !== "") {
          input.__validationStarted = true;
        }
        if (input.__validationStarted) {
          updateFieldStatus(fieldGroup);
        }
      });

      input.addEventListener("blur", () => {
        input.__validationStarted = true;
        updateFieldStatus(fieldGroup);
      });
    });

    const triggerSubmit = () => {
      if (realSubmitInput.disabled) return;
      if (!validateAndStartLiveValidationForAll()) return;

      if (isSpam()) {
        alert("Form submitted too quickly. Please try again.");
        return;
      }

      realSubmitInput.click();
    };

    dataSubmit.addEventListener("click", triggerSubmit);
    dataSubmit.addEventListener("keydown", (event) => {
      if (event.key === " ") {
        event.preventDefault();
        triggerSubmit();
      }
    });

    form.addEventListener("keydown", (event) => {
      if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
        triggerSubmit();
      }
    });
  });
}

document
  .getElementById("inquiry-form")
  .addEventListener("submit", async (e) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    const btn =
      formEl.querySelector("#submit-btn") ||
      formEl.querySelector('[type="submit"]');
    const submitUi = formEl.querySelector("[data-submit]");
    btn?.setAttribute("disabled", "disabled");
    submitUi?.classList.add("is--loading");
    submitUi?.setAttribute("aria-disabled", "true");

    const formData = new FormData(e.target);

    const isInStore = cleanWhitespace(formData.get("operation")) === "In-Store Pickup";

    let street = "", city = "", state = "", postal = "", siteAddress = "";

    if (isInStore) {
      const location = cleanWhitespace(formData.get("pickupLocation"));
      siteAddress = location ?? "";
    } else {
      // Pull raw values
      const rawStreet = formData.get("street-address");
      const rawCity = formData.get("city");
      const rawState = formData.get("state");
      const rawPostal = formData.get("postal-code");

      // Clean values
      street = cleanStreetAddress(rawStreet);
      city = cleanCity(rawCity);
      state = cleanState(rawState);
      postal = cleanPostal(rawPostal);
      if (state !== "CA") {
        toastr.error("We only offer catering in the San Gabriel Valley, CA.");
        btn?.removeAttribute("disabled");
        submitUi?.classList.remove("is--loading");
        submitUi?.removeAttribute("aria-disabled");
        return;
      }
      siteAddress = formatSiteAddress({
        street,
        city,
        stateCode: state,
        postalCode: postal,
      });
    }

    const plannedGuestCount = (() => {
      const v = cleanWhitespace(formData.get("plannedGuestCount"));
      if (!v) return "";
      return v;
    })();

    const docData = {
      dateCreated: new Date().toISOString(),

      firstName: titleCase(formData.get("firstName")),
      lastName: titleCase(formData.get("lastName")),
      email: cleanEmail(formData.get("email")),
      phoneNumber: cleanPhone(formData.get("phoneNumber")),

      company: titleCase(formData.get("company")),
      eventName: titleCase(formData.get("eventName")),
      eventDate: cleanWhitespace(formData.get("eventDate")),

      siteAddressStreet: street,
      siteAddressCity: city,
      siteAddressStateCode: state,
      siteAddressPostalCode: postal,
      siteAddressCountryCode: "US",
      siteAddress,
      startTime: cleanWhitespace(formData.get("startTime")),
      endTime: cleanWhitespace(formData.get("endTime")),

      plannedGuestCount,
      operation: cleanWhitespace(formData.get("operation")),
      package: cleanWhitespace(formData.get("packageChoice")),
      notes: cleanNotes(formData.get("notes")),
      reference: titleCase(formData.get("reference")),
    };

    try {
      await submitInquiry(docData);
      toastr.success("We got your inquiry! 🎉");
      webInquiry.classList.remove("web-inquiry-open");
      formEl.reset();
      document.getElementById("packageOption").innerHTML = "";
      const addressGrid = document.getElementById("form-address-grid");
      addressGrid.style.display = "";
      ADDRESS_FIELD_IDS.forEach((id) => {
        document.getElementById(id)?.setAttribute("required", "");
      });
      document.querySelector('label[for="eventDate"]').innerHTML = 'Event Date <span class="form-required">*</span>';
      document.querySelector('label[for="startTime"]').innerHTML = 'Start Time <span class="form-required">*</span>';
      const endTimeGroup = document.getElementById("endTime").closest(".form-field-group");
      endTimeGroup.style.display = "";
      document.getElementById("endTime").setAttribute("required", "");
      const fpTimeGroups = document.querySelectorAll(".fp-time-group");
      if (fpTimeGroups.length >= 2) {
        fpTimeGroups[0].querySelector(".fp-time-label").textContent = "Start Time";
        fpTimeGroups[1].style.display = "";
      }
      formEl.querySelectorAll("[data-validate]").forEach((fieldGroup) => {
        fieldGroup.classList.remove("is--error", "is--success", "is--filled");
        fieldGroup
          .querySelectorAll("input, textarea, select")
          .forEach((input) => {
            input.__validationStarted = false;
          });
      });
    } catch (err) {
      console.error("Submit failed:", err);
      await logFailedInquiryAttempt(docData, err);
      toastr.error(getInquirySubmitErrorMessage(err));
    } finally {
      btn?.removeAttribute("disabled");
      submitUi?.classList.remove("is--loading");
      submitUi?.removeAttribute("aria-disabled");
    }
  });

document.addEventListener("DOMContentLoaded", () => {
  initAdvancedFormValidation();
  initDateTimePickers();
});

function initDateTimePickers() {
  const eventDateInput = document.getElementById("eventDate");
  const startTimeInput = document.getElementById("startTime");
  const endTimeInput = document.getElementById("endTime");
  if (!eventDateInput) return;

  const dateFp = flatpickr(eventDateInput, {
    dateFormat: "Y-m-d",
    altInput: true,
    altFormat: "F j, Y",
    altInputClass: "form-input",
    minDate: "today",
    closeOnSelect: false,
    disableMobile: true,
    onReady(sd, ds, instance) {
      injectTimeFooter(instance, startTimeInput, endTimeInput);
    },
    onChange() {
      eventDateInput.dispatchEvent(new Event("input", { bubbles: true }));
    },
    onClose() {
      eventDateInput.dispatchEvent(new Event("blur", { bubbles: true }));
    },
  });

  if (startTimeInput) startTimeInput.addEventListener("click", () => dateFp.open());
  if (endTimeInput) endTimeInput.addEventListener("click", () => dateFp.open());
}

function injectTimeFooter(instance, startInput, endInput) {
  const footer = document.createElement("div");
  footer.className = "fp-footer";
  footer.innerHTML = `
    <div class="fp-time-group">
      <span class="fp-time-label">Start Time</span>
      <input class="fp-inline-time" id="fp-start" type="text" readonly>
    </div>
    <div class="fp-time-group">
      <span class="fp-time-label">End Time</span>
      <input class="fp-inline-time" id="fp-end" type="text" readonly>
    </div>
  `;
  instance.calendarContainer.appendChild(footer);

  flatpickr(footer.querySelector("#fp-start"), {
    enableTime: true,
    noCalendar: true,
    dateFormat: "h:i K",
    minuteIncrement: 1,
    inline: true,
    onChange(sd) {
      if (startInput && sd[0]) {
        const h = String(sd[0].getHours()).padStart(2, "0");
        const m = String(sd[0].getMinutes()).padStart(2, "0");
        startInput.value = `${h}:${m}`;
        startInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    },
  });

  flatpickr(footer.querySelector("#fp-end"), {
    enableTime: true,
    noCalendar: true,
    dateFormat: "h:i K",
    minuteIncrement: 1,
    inline: true,
    onChange(sd) {
      if (endInput && sd[0]) {
        const h = String(sd[0].getHours()).padStart(2, "0");
        const m = String(sd[0].getMinutes()).padStart(2, "0");
        endInput.value = `${h}:${m}`;
        endInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    },
  });
}

const ADDRESS_FIELD_IDS = ["street-address", "city", "state", "postal-code"];

document.getElementById("operation").addEventListener("change", function () {
  const selectedValue = this.value;
  const packageOption = document.getElementById("packageOption");
  const addressGrid = document.getElementById("form-address-grid");
  const isInStore = selectedValue === "In-Store Pickup";

  packageOption.innerHTML = "";

  // Show/hide address grid and toggle required on its fields
  addressGrid.style.display = isInStore ? "none" : "";
  ADDRESS_FIELD_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    isInStore ? el.removeAttribute("required") : el.setAttribute("required", "");
  });

  // Update date/time labels and hide end time for in-store pickup
  document.querySelector('label[for="eventDate"]').innerHTML = isInStore ? 'Pickup Date <span class="form-required">*</span>' : 'Event Date <span class="form-required">*</span>';
  document.querySelector('label[for="startTime"]').innerHTML = isInStore ? 'Pickup Time <span class="form-required">*</span>' : 'Start Time <span class="form-required">*</span>';
  const endTimeGroup = document.getElementById("endTime").closest(".form-field-group");
  endTimeGroup.style.display = isInStore ? "none" : "";
  document.getElementById("endTime")[isInStore ? "removeAttribute" : "setAttribute"]("required", "");

  // Update labels and visibility inside the flatpickr calendar footer
  const fpTimeGroups = document.querySelectorAll(".fp-time-group");
  if (fpTimeGroups.length >= 2) {
    fpTimeGroups[0].querySelector(".fp-time-label").textContent = isInStore ? "Pickup Time" : "Start Time";
    fpTimeGroups[1].style.display = isInStore ? "none" : "";
  }

  if (selectedValue === "Handel's on Wheels Truck") {
    packageOption.innerHTML = `
      <label for="packageChoice" class="form-label">Package Choice <span class="form-required">*</span></label>
      <div class="form-field">
        <select id="packageChoice" name="packageChoice" class="form-input" required>
          <option value="">Choose a package</option>
          <option value="Basic">Basic</option>
          <option value="Deluxe">Deluxe</option>
          <option value="Premium">Premium</option>
          <option value="Custom">Custom (Let us know what you're thinking below!)</option>
        </select>
        <div class="form-field-chevron" aria-hidden="true">&#9662;</div>
      </div>
    `;
  } else if (isInStore) {
    packageOption.innerHTML = `
      <label for="pickupLocation" class="form-label">Pickup Location <span class="form-required">*</span></label>
      <div class="form-field">
        <select id="pickupLocation" name="pickupLocation" class="form-input" required>
          <option value="">Choose a location</option>
          <option value="Glendora">Glendora</option>
          <option value="Pasadena">Pasadena</option>
          <option value="La Cañada">La Cañada</option>
          <option value="Alhambra">Alhambra</option>
        </select>
        <div class="form-field-chevron" aria-hidden="true">&#9662;</div>
      </div>
    `;
  }
});

/**
 * Book Us Button (Web Inquiry)
 */

function openInquiry(e, operationValue, packageValue) {
  e.preventDefault();
  webInquiry.classList.add("web-inquiry-open");
  if (operationValue) {
    const operationSelect = document.getElementById("operation");
    operationSelect.value = operationValue;
    // dispatchEvent is synchronous — package dropdown is injected before next line
    operationSelect.dispatchEvent(new Event("change"));
    if (packageValue) {
      const packageSelect = document.getElementById("packageChoice");
      if (packageSelect) packageSelect.value = packageValue;
    }
  }
  e.stopPropagation();
}

bookUs.forEach((button) => {
  button.addEventListener("click", openInquiry);
});

quoteButtons.forEach((button) => {
  button.addEventListener("click", (e) =>
    openInquiry(e, button.dataset.operation, button.dataset.package)
  );
});

close.addEventListener("click", () => {
  webInquiry.classList.remove("web-inquiry-open");
});

document.addEventListener("click", (e) => {
  const clickedOpenTrigger = e.target.closest(".book-us-btn, .flick-card__btn");
  const clickedFlatpickr = e.target.closest(".flatpickr-calendar");
  if (!inquiryContent.contains(e.target) && !clickedOpenTrigger && !clickedFlatpickr) {
    webInquiry.classList.remove("web-inquiry-open");
  }
});

/**
 * Scroll Trigger animations
 */

const packageCard = gsap.utils.toArray(".package-card");
packageCard.forEach((card) => {
  gsap.from(".package-card", {
    opacity: 0,
    x: 400,
  });

  gsap.to(".package-card", {
    scrollTrigger: {
      trigger: ".package-card",
      toggleActions: "restart none none none",
      start: "top bottom",
      end: "bottom top",
    },
    opacity: 1,
    x: 0,
    stagger: {
      each: 0.1,
    },
    duration: 1,
  });
});

gsap.from(".why-handels-wrapper", {
  y: 200,
});

gsap.to(".why-handels-wrapper", {
  scrollTrigger: {
    trigger: ".why-handels",
    scrub: 2,
    start: "top bottom",
    end: "bottom center",
  },
  y: -125,
});

gsap.from(".why-text", {
  opacity: 0,
  x: 200,
});

gsap.to(".why-text", {
  scrollTrigger: {
    trigger: ".why-handels",
    toggleActions: "restart none none none",
    start: "top 70%",
    end: "bottom bottom",
  },
  opacity: 1,
  x: 0,
  duration: 1,
});

// Navbar animations
{
  window.addEventListener(
    "scroll",
    function () {
      var navbar = document.getElementById("navbar");
      var spacer = document.getElementById("nav-spacer");
      if (!navbar.classList.contains("sticky")) {
        if (window.scrollY > 800) {
          // Reserve the navbar's in-flow height before it goes fixed so the
          // page doesn't collapse upward into the gap it leaves behind.
          spacer.style.height = navbar.offsetHeight + "px";
          navbar.classList.add("sticky");
        }
      } else if (window.scrollY < 300) {
        navbar.classList.remove("sticky");
        navbar.classList.add("sticky-gone");
      }

      if (navbar.classList.contains("sticky-gone") && window.scrollY < 150) {
        navbar.classList.remove("sticky-gone");
        spacer.style.height = "0px";
      }
    },
    { passive: true }
  );
}

// navbar toggler
{
  const toggleButton = document.getElementsByClassName("nav-toggle-button")[0];
  const navbarLinks = document.getElementsByClassName("nav-links")[0];
  const navbar = document.getElementsByClassName("navbar")[0];

  toggleButton.addEventListener("click", () => {
    navbarLinks.classList.toggle("active");
    navbar.classList.toggle("nav-active");
  });
}

/**
 * Magnetic Truck
 */
const truck = document.querySelector(".truck-lights");
const area = document.querySelector(".area");

const lerp = (x, y, a) => x * (1 - a) + y * a;

area.addEventListener("mousemove", (dets) => {
  const drim = area.getBoundingClientRect();
  const xStart = drim.x;
  const xEnd = drim.x + drim.width;
  const leftRight = gsap.utils.mapRange(xStart, xEnd, 0, 1, dets.clientX);
  const yStart = drim.y;
  const yEnd = drim.y + drim.height;
  const upDown = gsap.utils.mapRange(yStart, yEnd, 0, 1, dets.clientY);
  gsap.to(".truck", {
    x: lerp(-25, 25, leftRight),
    y: lerp(-25, 25, upDown),
  });
  gsap.to(".truck-lights", {
    x: lerp(-25, 25, leftRight),
    y: lerp(-25, 25, upDown),
  });
  gsap.to(".blob", {
    x: lerp(-15, 15, leftRight),
    y: lerp(-15, 15, upDown),
  });
});

area.addEventListener("mouseleave", (dets) => {
  gsap.to(".truck", {
    ease: "elastic.out(1, 0.2)",
    duration: 2,
    x: 0,
    y: 0,
  });
  gsap.to(".truck-lights", {
    ease: "elastic.out(1, 0.2)",
    duration: 2,
    x: 0,
    y: 0,
  });
  gsap.to(".blob", {
    ease: "elastic.out(1, 0.2)",
    duration: 2,
    x: 0,
    y: 0,
  });
});

truck.addEventListener("click", () => {
  const lights = document.querySelector(".truck-lights");
  lights.classList.toggle("active");
});

let truckLights = document.getElementsByClassName("truck-lights")[0];

area.addEventListener("click", () => {
  truckLights.classList.toggle("active");
});
// END Magnetic truck ------------------------------------

const scrollers = document.querySelectorAll(".scroller");

// If a user hasn't opted in for recuded motion, then we add the animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

addAnimation();

function addAnimation() {
  scrollers.forEach((scroller) => {
    // add data-animated="true" to every `.scroller` on the page
    scroller.setAttribute("data-animated", true);

    // Make an array from the elements within `.scroller-inner`
    const scrollerInner = scroller.querySelector(".scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });

    // Hover effect
  });
}

function initDraggableMarquee() {
  const wrappers = document.querySelectorAll("[data-draggable-marquee-init]");

  const getNumberAttr = (el, name, fallback) => {
    const value = parseFloat(el.getAttribute(name));
    return Number.isFinite(value) ? value : fallback;
  };

  wrappers.forEach((wrapper) => {
    if (wrapper.getAttribute("data-draggable-marquee-init") === "initialized")
      return;

    const collection = wrapper.querySelector(
      "[data-draggable-marquee-collection]",
    );
    const list = wrapper.querySelector("[data-draggable-marquee-list]");
    if (!collection || !list) return;

    const duration = getNumberAttr(wrapper, "data-duration", 20);
    const multiplier = getNumberAttr(wrapper, "data-multiplier", 40);
    const sensitivity = getNumberAttr(wrapper, "data-sensitivity", 0.01);

    const wrapperWidth = wrapper.getBoundingClientRect().width;
    const listWidth = list.scrollWidth || list.getBoundingClientRect().width;
    if (!wrapperWidth || !listWidth) return;

    // Make enough duplicates to cover screen
    const minRequiredWidth = wrapperWidth + listWidth + 2;
    while (collection.scrollWidth < minRequiredWidth) {
      const listClone = list.cloneNode(true);
      listClone.setAttribute("data-draggable-marquee-clone", "");
      listClone.setAttribute("aria-hidden", "true");
      collection.appendChild(listClone);
    }

    const wrapX = gsap.utils.wrap(-listWidth, 0);

    gsap.set(collection, { x: 0 });

    const marqueeLoop = gsap.to(collection, {
      x: -listWidth,
      duration,
      ease: "none",
      repeat: -1,
      onReverseComplete: () => marqueeLoop.progress(1),
      modifiers: {
        x: (x) => wrapX(parseFloat(x)) + "px",
      },
    });

    // Direction can be used for css + set initial direction on load
    const initialDirectionAttr = (
      wrapper.getAttribute("data-direction") || "left"
    ).toLowerCase();
    const baseDirection = initialDirectionAttr === "right" ? -1 : 1;

    const timeScale = { value: 1 };

    timeScale.value = baseDirection;
    wrapper.setAttribute(
      "data-direction",
      baseDirection < 0 ? "right" : "left",
    );

    if (baseDirection < 0) marqueeLoop.progress(1);

    function applyTimeScale() {
      marqueeLoop.timeScale(timeScale.value);
      wrapper.setAttribute(
        "data-direction",
        timeScale.value < 0 ? "right" : "left",
      );
    }

    applyTimeScale();

    // Drag observer
    const marqueeObserver = Observer.create({
      target: wrapper,
      type: "pointer,touch",
      preventDefault: true,
      debounce: false,
      onChangeX: (observerEvent) => {
        let velocityTimeScale = observerEvent.velocityX * -sensitivity;
        velocityTimeScale = gsap.utils.clamp(
          -multiplier,
          multiplier,
          velocityTimeScale,
        );

        gsap.killTweensOf(timeScale);

        const restingDirection = velocityTimeScale < 0 ? -1 : 1;

        gsap
          .timeline({ onUpdate: applyTimeScale })
          .to(timeScale, {
            value: velocityTimeScale,
            duration: 0.1,
            overwrite: true,
          })
          .to(timeScale, { value: restingDirection, duration: 1.0 });
      },
    });

    // Pause marquee when scrolled out of view
    ScrollTrigger.create({
      trigger: wrapper,
      start: "top bottom",
      end: "bottom top",
      onEnter: () => {
        marqueeLoop.resume();
        applyTimeScale();
        marqueeObserver.enable();
      },
      onEnterBack: () => {
        marqueeLoop.resume();
        applyTimeScale();
        marqueeObserver.enable();
      },
      onLeave: () => {
        marqueeLoop.pause();
        marqueeObserver.disable();
      },
      onLeaveBack: () => {
        marqueeLoop.pause();
        marqueeObserver.disable();
      },
    });

    wrapper.setAttribute("data-draggable-marquee-init", "initialized");
  });
}

// Initialize Draggable Marquee (Directional)
document.addEventListener("DOMContentLoaded", () => {
  initDraggableMarquee();
});

function initRadialTextMarquee() {
  const wraps = document.querySelectorAll("[data-radial-text-marquee-init]");
  if (!wraps.length) return;

  const ns = "http://www.w3.org/2000/svg";
  const xns = "http://www.w3.org/1999/xlink";
  const prm =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isSafari = (() => {
    const ua = navigator.userAgent;
    return /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR/i.test(ua);
  })();

  const clamp = (n, a, b) => Math.min(b, Math.max(a, Number(n) || 0));

  const speedMul = () => {
    const w = window.innerWidth || 2000;
    const t = clamp((w - 250) / (2000 - 250), 0, 1);
    return 0.5 + t * (1 - 0.5);
  };

  const lsToPx = (ls, fs) => {
    if (!ls || ls === "normal") return 0;
    if (ls.endsWith("px")) return parseFloat(ls) || 0;
    if (ls.endsWith("em")) return (parseFloat(ls) || 0) * fs;
    if (ls.endsWith("rem")) {
      const root =
        parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      return (parseFloat(ls) || 0) * root;
    }
    const n = parseFloat(ls);
    return Number.isFinite(n) ? n : 0;
  };

  const syncType = (fromEl, svgText, svgTextPath) => {
    const s = getComputedStyle(fromEl);
    const fsPx = parseFloat(s.fontSize) || 16;
    const lsPx = lsToPx(s.letterSpacing, fsPx);

    svgText.setAttribute("font-family", s.fontFamily);
    svgText.setAttribute("font-size", s.fontSize);
    svgText.setAttribute("font-weight", s.fontWeight);
    svgText.setAttribute("dominant-baseline", "alphabetic");
    svgText.setAttribute("text-rendering", "geometricPrecision");
    svgText.setAttribute("fill", s.color);

    svgText.setAttribute("letter-spacing", `${lsPx}px`);
    svgText.setAttribute("font-kerning", "none");
    svgText.setAttribute(
      "font-feature-settings",
      '"kern" 0, "liga" 0, "clig" 0',
    );

    if (svgTextPath) svgTextPath.setAttribute("letter-spacing", `${lsPx}px`);

    return { fsPx, lsPx, ff: s.fontFamily, fw: s.fontWeight, fz: s.fontSize };
  };

  const tspan = (tp, v, fill, lsPx) => {
    const t = document.createElementNS(ns, "tspan");
    t.textContent = v;
    if (fill) t.setAttribute("fill", fill);
    if (lsPx != null) t.setAttribute("letter-spacing", `${lsPx}px`);
    tp.appendChild(t);
  };

  const buildRun = (tp, text, spacer, spacerColor, pad, reps, lsPx) => {
    tp.textContent = "";
    for (let i = 0; i < reps; i++) {
      tspan(tp, text, null, lsPx);
      tspan(tp, pad, null, lsPx);
      tspan(tp, spacer, spacerColor, lsPx);
      tspan(tp, pad, null, lsPx);
    }
  };

  const circleR = (half, level01) => {
    if (level01 <= 0) return half * 200;
    const inv = 1 - level01;
    return half * (1.01 + inv * inv * 16.99);
  };

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const measureLS = (str, fontCss, lsPx) => {
    if (!ctx) return 0;
    ctx.font = fontCss;
    const txt = (str || "").replace(/\u00A0/g, " ");
    const w = ctx.measureText(txt).width || 0;
    const glyphs = Array.from(txt).length;
    return w + Math.max(glyphs - 1, 0) * (lsPx || 0);
  };

  const setPlaying = (st, play) => {
    st.inView = play;
    if (!st.tw) return;
    if (prm) return st.tw.pause();
    play ? st.tw.play() : st.tw.pause();
  };

  const makeSvg = (wrap) => {
    const svg = document.createElementNS(ns, "svg");
    const defs = document.createElementNS(ns, "defs");
    const g = document.createElementNS(ns, "g");
    const path = document.createElementNS(ns, "path");
    const text = document.createElementNS(ns, "text");
    const tp = document.createElementNS(ns, "textPath");
    const id = `rtm-${Math.random().toString(16).slice(2)}`;

    svg.setAttribute("xmlns", ns);
    svg.setAttribute("xmlns:xlink", xns);
    Object.assign(svg.style, {
      position: "absolute",
      top: 0,
      left: 0,
      overflow: "visible",
      pointerEvents: "none",
      display: "block",
    });
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");

    path.setAttribute("id", id);
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "none");

    tp.setAttributeNS(xns, "xlink:href", `#${id}`);
    tp.setAttribute("text-anchor", "start");
    tp.setAttribute("startOffset", "0px");

    text.appendChild(tp);
    defs.appendChild(path);
    svg.appendChild(defs);
    g.appendChild(path);
    g.appendChild(text);
    svg.appendChild(g);
    wrap.appendChild(svg);

    const textEl = wrap.querySelector("[data-radial-text-marquee-text]");
    if (textEl) textEl.style.opacity = "0";

    return { svg, g, path, text, tp };
  };

  wraps.forEach((wrap) => {
    const textEl = wrap.querySelector("[data-radial-text-marquee-text]");
    if (!textEl) return;

    const st = {
      ...makeSvg(wrap),
      tw: null,
      px: { x: 0 },
      inView: true,
      raf: 0,
      qs: null,
    };
    new IntersectionObserver(
      (e) => setPlaying(st, !!(e[0] && e[0].isIntersecting)),
      { threshold: 0 },
    ).observe(wrap);

    const rebuild = () => {
      const baseText = (textEl.textContent || "").trim();
      if (!baseText) return;

      const speed = clamp(
        wrap.getAttribute("data-radial-text-marquee-speed") || 4,
        0.1,
        200,
      );
      const speedPx = Math.max(speed * 100 * speedMul(), 1);

      const radiusLevel = clamp(
        wrap.getAttribute("data-radial-text-marquee-radius") || 10,
        0,
        10,
      );
      const level01 = radiusLevel / 10;

      const spacer =
        wrap.getAttribute("data-radial-text-marquee-spacer") || "•";
      const spacerColor =
        wrap.getAttribute("data-radial-text-marquee-spacer-color") || null;

      const padCount = clamp(
        wrap.getAttribute("data-radial-text-marquee-spacer-padding") || 1,
        0,
        20,
      );
      const pad = "\u00A0".repeat(padCount);

      const typo = syncType(textEl, st.text, st.tp);

      const wrapW = Math.max(wrap.clientWidth || 1, 1);
      const wrapH = Math.max(wrap.clientHeight || textEl.offsetHeight || 1, 1);
      const bleed = typo.fsPx * 2;

      const w = wrapW + bleed * 2;
      const h = wrapH;

      Object.assign(st.svg.style, {
        width: `${w}px`,
        height: `${h}px`,
        left: `${-bleed}px`,
      });
      st.svg.setAttribute("width", w);
      st.svg.setAttribute("height", h);
      st.svg.setAttribute("viewBox", `0 0 ${w} ${h}`);

      const half = w / 2;
      const r =
        level01 <= 0.0001
          ? half * 200
          : Math.max(circleR(half, level01), half + 0.001);
      const under = Math.max(r * r - half * half, 0);
      const y = Math.max(r - Math.sqrt(under), 0);

      st.path.setAttribute(
        "d",
        level01 <= 0.0001
          ? `M 0 ${y} L ${w} ${y}`
          : `M 0 ${y} A ${r} ${r} 0 0 1 ${w} ${y}`,
      );

      st.text.setAttribute("x", "0");
      st.text.setAttribute("y", `${y}`);
      st.g.setAttribute("transform", `translate(0 ${typo.fsPx})`);
      textEl.style.opacity = "0";

      cancelAnimationFrame(st.raf);
      st.raf = requestAnimationFrame(() => {
        const fontCss = `${typo.fw} ${typo.fz} ${typo.ff}`;

        let loopLen =
          measureLS(baseText, fontCss, typo.lsPx) +
          measureLS(pad, fontCss, typo.lsPx) +
          measureLS(spacer, fontCss, typo.lsPx) +
          measureLS(pad, fontCss, typo.lsPx);

        loopLen = Math.max(loopLen || 0, 1);

        const pathLen = st.path.getTotalLength
          ? st.path.getTotalLength()
          : wrapW;
        const targetCover = Math.max(pathLen * 4, wrapW * 8);

        const reps = clamp(Math.ceil(targetCover / loopLen) + 6, 6, 600);
        buildRun(st.tp, baseText, spacer, spacerColor, pad, reps, typo.lsPx);

        if (!isSafari) {
          const fullLen = st.tp.getComputedTextLength();
          if (Number.isFinite(fullLen) && fullLen > 0) {
            const perUnit = fullLen / reps;
            if (Number.isFinite(perUnit) && perUnit > 0) loopLen = perUnit;
          }
        }

        loopLen = Math.max(loopLen, 1);

        if (st.tw) st.tw.kill();
        st.tw = null;
        if (prm) return;

        st.qs =
          gsap && gsap.quickSetter ? gsap.quickSetter(st.tp, "attr") : null;

        const setOffset = (v) => {
          const val = `${v.toFixed(3)}px`;
          if (st.qs) st.qs({ startOffset: val });
          else st.tp.setAttribute("startOffset", val);
        };

        st.px.x = 0;
        st.tw = gsap.to(st.px, {
          x: loopLen,
          duration: loopLen / speedPx,
          ease: "none",
          repeat: -1,
          onUpdate: () => {
            const x = ((st.px.x % loopLen) + loopLen) % loopLen;
            setOffset(-x);
          },
        });

        setPlaying(st, st.inView);
      });
    };

    const schedule = (() => {
      let raf = 0;
      return () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(rebuild);
      };
    })();

    rebuild();

    if (document.fonts && document.fonts.ready)
      document.fonts.ready.then(schedule).catch(() => {});
    else setTimeout(schedule, 150);

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(schedule);
      ro.observe(wrap);
      ro.observe(textEl);
    } else {
      window.addEventListener("resize", schedule);
    }
  });
}

// Initialize Radial Text Marquee
document.addEventListener("DOMContentLoaded", function () {
  initRadialTextMarquee();
});

// Note: The Javascript is optional. Read the documentation below how to use the CSS Only version.

function initCSSMarquee() {
  const pixelsPerSecond = 75; // Set the marquee speed (pixels per second)
  const marquees = document.querySelectorAll("[data-css-marquee]");

  // Duplicate each [data-css-marquee-list] element inside its container
  marquees.forEach((marquee) => {
    marquee.querySelectorAll("[data-css-marquee-list]").forEach((list) => {
      const duplicate = list.cloneNode(true);
      marquee.appendChild(duplicate);
    });
  });

  // Create an IntersectionObserver to check if the marquee container is in view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target
          .querySelectorAll("[data-css-marquee-list]")
          .forEach(
            (list) =>
              (list.style.animationPlayState = entry.isIntersecting
                ? "running"
                : "paused"),
          );
      });
    },
    { threshold: 0 },
  );

  // Calculate the width and set the animation duration accordingly
  marquees.forEach((marquee) => {
    marquee.querySelectorAll("[data-css-marquee-list]").forEach((list) => {
      list.style.animationDuration = list.offsetWidth / pixelsPerSecond + "s";
      list.style.animationPlayState = "paused";
    });
    observer.observe(marquee);
  });
}

// Initialize CSS Marquee
document.addEventListener("DOMContentLoaded", function () {
  initCSSMarquee();
});

function initDirectionalButtonHover() {
  // Button hover animation
  document.querySelectorAll("[data-btn-hover]").forEach((button) => {
    button.addEventListener("mouseenter", handleHover);
    button.addEventListener("mouseleave", handleHover);
  });

  function handleHover(event) {
    const button = event.currentTarget;
    const buttonRect = button.getBoundingClientRect();

    // Get the button's dimensions and center
    const buttonWidth = buttonRect.width;
    const buttonHeight = buttonRect.height;
    const buttonCenterX = buttonRect.left + buttonWidth / 2;
    const buttonCenterY = buttonRect.top + buttonHeight / 2;

    // Calculate mouse position
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    // Offset from the top-left corner in percentage
    const offsetXFromLeft = ((mouseX - buttonRect.left) / buttonWidth) * 100;
    const offsetYFromTop = ((mouseY - buttonRect.top) / buttonHeight) * 100;

    // Offset from the center in percentage
    let offsetXFromCenter = ((mouseX - buttonCenterX) / (buttonWidth / 2)) * 50;

    // Convert to absolute values
    offsetXFromCenter = Math.abs(offsetXFromCenter);

    // Update position and size of .btn__circle
    const circle = button.querySelector(".btn__circle");
    if (circle) {
      circle.style.left = `${offsetXFromLeft.toFixed(1)}%`;
      circle.style.top = `${offsetYFromTop.toFixed(1)}%`;
      circle.style.width = `${115 + offsetXFromCenter.toFixed(1) * 2}%`;
    }
  }
}

// Initialize Directional Button Hover
document.addEventListener("DOMContentLoaded", function () {
  initDirectionalButtonHover();
});

gsap.registerPlugin(Draggable);

function initFlickCards() {
  const sliders = document.querySelectorAll("[data-flick-cards-init]");

  sliders.forEach((slider) => {
    const list = slider.querySelector("[data-flick-cards-list]");
    if (!list) return;

    const allCards = Array.from(list.querySelectorAll("[data-flick-cards-item]"));
    const maxCards = slider.closest(".truck-packages")
      ? 5
      : slider.closest(".tableside-packages")
        ? 1
        : allCards.length;

    const cards = allCards.slice(0, maxCards);
    allCards.slice(maxCards).forEach((card) => card.remove());

    const total = cards.length;
    if (!total) return;
    let activeIndex = 0;

    const sliderWidth = slider.offsetWidth;
    const threshold = 0.1;
    const maxStackTilt = 4.5;

    let prevButton, nextButton;

    if (total > 1) {
      prevButton = document.createElement("button");
      prevButton.type = "button";
      prevButton.className = "flick-group__arrow flick-group__arrow--prev";
      prevButton.setAttribute("data-flick-cards-prev", "");
      prevButton.setAttribute("aria-label", "Previous package");
      prevButton.innerHTML = "&#8592;";

      nextButton = document.createElement("button");
      nextButton.type = "button";
      nextButton.className = "flick-group__arrow flick-group__arrow--next";
      nextButton.setAttribute("data-flick-cards-next", "");
      nextButton.setAttribute("aria-label", "Next package");
      nextButton.innerHTML = "&#8594;";

      slider.appendChild(prevButton);
      slider.appendChild(nextButton);
    }

    // Generate draggers inside each card and store references
    const draggers = [];
    cards.forEach((card) => {
      const dragger = document.createElement("div");
      dragger.setAttribute("data-flick-cards-dragger", "");
      card.appendChild(dragger);
      draggers.push(dragger);
    });

    // Set initial drag status
    slider.setAttribute("data-flick-drag-status", "grab");

    const clampIndex = (index) => Math.max(0, Math.min(total - 1, index));

    function updateControls() {
      if (!prevButton || !nextButton) return;
      prevButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === total - 1;
    }

    function setStackTilt(rawProgress) {
      const normalized = Math.max(-1, Math.min(1, rawProgress));
      gsap.set(list, {
        rotation: normalized * maxStackTilt,
        transformOrigin: "50% 55%",
      });
    }

    function getConfig(i, currentIndex) {
      const diff = i - currentIndex;

      switch (diff) {
        case 0:
          return { x: 0, y: 0, rot: 0, s: 1, o: 1, z: 5 };
        case 1:
          return { x: 25, y: 1, rot: 10, s: 0.9, o: 1, z: 4 };
        case -1:
          return { x: -25, y: 1, rot: -10, s: 0.9, o: 1, z: 4 };
        case 2:
          return { x: 45, y: 5, rot: 15, s: 0.8, o: 1, z: 3 };
        case -2:
          return { x: -45, y: 5, rot: -15, s: 0.8, o: 1, z: 3 };
        default:
          const dir = diff > 0 ? 1 : -1;
          return { x: 55 * dir, y: 5, rot: 20 * dir, s: 0.6, o: 0, z: 2 };
      }
    }

    function renderCards(currentIndex) {
      cards.forEach((card, i) => {
        const cfg = getConfig(i, currentIndex);
        let status;

        if (cfg.x === 0) status = "active";
        else if (cfg.x === 25) status = "2-after";
        else if (cfg.x === -25) status = "2-before";
        else if (cfg.x === 45) status = "3-after";
        else if (cfg.x === -45) status = "3-before";
        else status = "hidden";

        card.setAttribute("data-flick-cards-item-status", status);
        card.style.zIndex = cfg.z;

        gsap.to(card, {
          duration: 0.6,
          ease: "elastic.out(1.2, 1)",
          xPercent: cfg.x,
          yPercent: cfg.y,
          rotation: cfg.rot,
          scale: cfg.s,
          opacity: cfg.o,
        });
      });

      updateControls();
    }

    function shiftCards(shift) {
      activeIndex = clampIndex(activeIndex + shift);
      renderCards(activeIndex);
    }

    renderCards(activeIndex);

    // Magnetic hover — pull each card toward the cursor, bounce back on leave.
    // Targets .flick-group__item (outer) so .flick-card never gets a GSAP transform,
    // preserving the original z-index stacking that keeps the button above the dragger.
    // Uses killTweensOf(card, "x,y") instead of overwrite:"auto" to avoid killing the
    // stack-position tweens (xPercent/yPercent/rotation/scale) on the same element.
    let magneticDragging = false;
    const MAGNETIC_MAX_PULL = 22;

    function getMagneticStrength(status) {
      if (status === "active") return 0.28;
      if (status === "2-after" || status === "2-before") return 0.16;
      if (status === "3-after" || status === "3-before") return 0.1;
      return 0;
    }

    slider.addEventListener("mousemove", (e) => {
      if (magneticDragging || matchMedia("(hover: none)").matches) return;
      cards.forEach((card, i) => {
        const status = card.getAttribute("data-flick-cards-item-status");
        const strength = getMagneticStrength(status);
        if (strength === 0) return;
        const inner = card.querySelector(".flick-card");
        const rect = inner.getBoundingClientRect();
        const dx = e.clientX - (rect.left + rect.width / 2);
        const dy = e.clientY - (rect.top + rect.height / 2);
        gsap.killTweensOf(card, "x,y");
        gsap.to(card, {
          x: Math.max(-MAGNETIC_MAX_PULL, Math.min(MAGNETIC_MAX_PULL, dx * strength)),
          y: Math.max(-MAGNETIC_MAX_PULL, Math.min(MAGNETIC_MAX_PULL, dy * strength * 0.25)),
          duration: 0.4,
          ease: "power2.out",
        });
      });
    });

    slider.addEventListener("mouseleave", () => {
      cards.forEach((card) => {
        gsap.killTweensOf(card, "x,y");
        gsap.to(card, {
          x: 0,
          y: 0,
          duration: 1,
          ease: "elastic.out(1, 0.4)",
        });
      });
    });

    if (total < 2) return;

    prevButton.addEventListener("click", () => shiftCards(-1));
    nextButton.addEventListener("click", () => shiftCards(1));

    let pressClientX = 0;
    let pressClientY = 0;

    Draggable.create(draggers, {
      type: "x",
      edgeResistance: 0.8,
      bounds: { minX: -sliderWidth / 2, maxX: sliderWidth / 2 },
      inertia: false,
      zIndexBoost: false,

      onPress() {
        magneticDragging = true;
        cards.forEach((card) => gsap.killTweensOf(card, "x,y"));
        pressClientX = this.pointerEvent.clientX;
        pressClientY = this.pointerEvent.clientY;
        gsap.killTweensOf(list);
        slider.setAttribute("data-flick-drag-status", "grabbing");
      },

      onDrag() {
        const rawProgress = this.x / sliderWidth;
        setStackTilt(rawProgress);
        const progress = Math.min(1, Math.abs(rawProgress));
        const direction = rawProgress > 0 ? -1 : 1;
        const nextIndex = clampIndex(activeIndex + direction);
        const isEdgeDrag = nextIndex === activeIndex;

        if (isEdgeDrag) {
          const edgePull = Math.max(-1, Math.min(1, rawProgress)) * 8;

          cards.forEach((card, i) => {
            const from = getConfig(i, activeIndex);

            gsap.set(card, {
              xPercent: from.x + edgePull,
              yPercent: from.y,
              rotation: from.rot + edgePull * 0.08,
              scale: from.s,
              opacity: from.o,
            });
          });

          return;
        }

        cards.forEach((card, i) => {
          const from = getConfig(i, activeIndex);
          const to = getConfig(i, nextIndex);
          const mix = (prop) => from[prop] + (to[prop] - from[prop]) * progress;

          gsap.set(card, {
            xPercent: mix("x"),
            yPercent: mix("y"),
            rotation: mix("rot"),
            scale: mix("s"),
            opacity: mix("o"),
          });
        });
      },

      onRelease() {
        magneticDragging = false;
        slider.setAttribute("data-flick-drag-status", "grab");

        const releaseClientX = this.pointerEvent.clientX;
        const releaseClientY = this.pointerEvent.clientY;
        const dragDistance = Math.hypot(
          releaseClientX - pressClientX,
          releaseClientY - pressClientY,
        );

        const raw = this.x / sliderWidth;
        let shift = 0;
        if (raw > threshold) shift = -1;
        else if (raw < -threshold) shift = 1;

        if (shift !== 0) {
          const nextIndex = clampIndex(activeIndex + shift);
          if (nextIndex !== activeIndex) {
            shiftCards(shift);
          } else {
            renderCards(activeIndex);
          }
        } else {
          renderCards(activeIndex);
        }

        gsap.to(this.target, {
          x: 0,
          duration: 0.3,
          ease: "power1.out",
        });

        gsap.to(list, {
          rotation: 0,
          duration: 0.45,
          ease: "elastic.out(1, 0.8)",
        });

        if (dragDistance < 4) {
          // Temporarily allow clicks to pass through
          this.target.style.pointerEvents = "none";

          // Allow the DOM to register pointer-through
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const el = document.elementFromPoint(
                releaseClientX,
                releaseClientY,
              );
              if (el) {
                const evt = new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: true,
                });
                el.dispatchEvent(evt);
              }

              // Restore pointer events
              this.target.style.pointerEvents = "auto";
            });
          });
        }
      },
    });
  });
}

// Initialize Flick Cards Slider
document.addEventListener("DOMContentLoaded", function () {
  initFlickCards();
});

function initImageCycle() {
  document.querySelectorAll("[data-image-cycle]").forEach((cycleElement) => {
    const items = cycleElement.querySelectorAll("[data-image-cycle-item]");
    if (items.length < 2) return;

    let currentIndex = 0;
    let intervalId = null;
    let isVisible = false;
    let isPaused = false;

    // Get optional custom duration (in seconds), fallback to 2000ms
    const attrValue = cycleElement.getAttribute("data-image-cycle");
    const duration =
      attrValue && !isNaN(attrValue) ? parseFloat(attrValue) * 1000 : 2000;
    const isTwoItems = items.length === 2;

    // Initial state
    items.forEach((item, i) => {
      item.setAttribute(
        "data-image-cycle-item",
        i === 0 ? "active" : "not-active",
      );
    });

    function cycleImages() {
      const prevIndex = currentIndex;
      currentIndex = (currentIndex + 1) % items.length;

      items[prevIndex].setAttribute("data-image-cycle-item", "previous");

      if (!isTwoItems) {
        setTimeout(() => {
          items[prevIndex].setAttribute("data-image-cycle-item", "not-active");
        }, duration);
      }

      items[currentIndex].setAttribute("data-image-cycle-item", "active");
    }

    // Start only when on-screen and not externally paused (e.g. by the lightbox)
    function start() {
      if (intervalId || !isVisible || isPaused) return;
      intervalId = setInterval(cycleImages, duration);
    }

    function stop() {
      clearInterval(intervalId);
      intervalId = null;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
        if (isVisible) start();
        else stop();
      },
      { threshold: 0 },
    );

    observer.observe(cycleElement);

    // Expose pause/resume so the click-to-zoom lightbox can hold rotation
    cycleElement._imageCyclePause = () => {
      isPaused = true;
      stop();
    };
    cycleElement._imageCycleResume = () => {
      isPaused = false;
      start();
    };
  });
}

// Initialize Image Cycle
document.addEventListener("DOMContentLoaded", function () {
  initImageCycle();
});

function initClickToZoomBasic() {
  const CONFIG = {
    openDuration: 0.55,
    closeDuration: 0.45,
    openEase: "power3.out",
    closeEase: "power2.inOut",

    closeOnScroll: true,
    closeOnEscape: true,
    closeOnClick: true,
  };

  const lightbox = document.querySelector("[data-click-zoom-lightbox]");
  if (!lightbox) return;

  lightbox.setAttribute("role", "dialog");
  lightbox.setAttribute("aria-modal", "true");
  lightbox.setAttribute("aria-hidden", "true");

  // Backdrop animates from transparent to the CSS-declared color.
  const backdropColor = window.getComputedStyle(lightbox).backgroundColor;
  const transparent = "rgba(0, 0, 0, 0)";

  let cloneEl = null;
  let isOpen = false;
  let isAnimating = false;
  let openScrollY = 0;
  let openSourceRectDoc = null;
  let pausedCycle = null;

  function computeFlip(src, dst) {
    return {
      scaleX: src.width / dst.width,
      scaleY: src.height / dst.height,
      tx: src.left + src.width / 2 - (dst.left + dst.width / 2),
      ty: src.top + src.height / 2 - (dst.top + dst.height / 2),
    };
  }

  function open(img) {
    if (isOpen || isAnimating) return;
    if (!img.complete || !img.naturalWidth) return;

    isAnimating = true;
    openScrollY = window.scrollY;

    // Hold the auto-rotation on this carousel while its image is zoomed
    pausedCycle = img.closest("[data-image-cycle]");
    if (pausedCycle && pausedCycle._imageCyclePause) pausedCycle._imageCyclePause();

    const srcRect = img.getBoundingClientRect();
    openSourceRectDoc = {
      top: srcRect.top + window.scrollY,
      left: srcRect.left,
      width: srcRect.width,
      height: srcRect.height,
    };

    cloneEl = img.cloneNode(false);
    cloneEl.loading = "eager";
    cloneEl.removeAttribute("data-click-zoom");
    // Reuse the already-decoded source (WebP from <picture>) so the clone
    // shows instantly instead of refetching the PNG fallback in src.
    if (img.currentSrc) cloneEl.src = img.currentSrc;

    const srcComputed = window.getComputedStyle(img);

    gsap.set(lightbox, { display: "flex", backgroundColor: transparent });

    const lightboxStyle = window.getComputedStyle(lightbox);
    const padX =
      parseFloat(lightboxStyle.paddingLeft) +
      parseFloat(lightboxStyle.paddingRight);
    const padY =
      parseFloat(lightboxStyle.paddingTop) +
      parseFloat(lightboxStyle.paddingBottom);
    const aspect = srcRect.width / srcRect.height;
    const maxW = lightbox.clientWidth - padX;
    const maxH = lightbox.clientHeight - padY;
    let w = maxW;
    let h = w / aspect;
    if (h > maxH) {
      h = maxH;
      w = h * aspect;
    }

    gsap.set(cloneEl, {
      width: w,
      height: h,
      display: "block",
      objectFit: srcComputed.objectFit,
      objectPosition: srcComputed.objectPosition,
    });

    while (lightbox.firstChild) lightbox.removeChild(lightbox.firstChild);
    lightbox.appendChild(cloneEl);

    const dstRect = cloneEl.getBoundingClientRect();
    const flip = computeFlip(srcRect, dstRect);

    lightbox.setAttribute("aria-hidden", "false");
    document.documentElement.style.cursor = "zoom-out";

    const tl = gsap.timeline({
      onComplete: () => {
        isAnimating = false;
        isOpen = true;
        attachCloseListeners();
      },
    });

    tl.to(
      lightbox,
      {
        backgroundColor: backdropColor,
        duration: 0.3,
        ease: "none",
      },
      0,
    );

    tl.fromTo(
      cloneEl,
      { x: flip.tx, y: flip.ty, scaleX: flip.scaleX, scaleY: flip.scaleY },
      {
        x: 0,
        y: 0,
        scaleX: 1,
        scaleY: 1,
        duration: CONFIG.openDuration,
        ease: CONFIG.openEase,
      },
      0,
    );
  }

  function close() {
    if (!isOpen || isAnimating) return;
    isAnimating = true;
    detachCloseListeners();
    document.documentElement.style.cursor = "";

    const dstRect = cloneEl.getBoundingClientRect();
    const startX = Number(gsap.getProperty(cloneEl, "x")) || 0;
    const startY = Number(gsap.getProperty(cloneEl, "y")) || 0;
    const startScaleX = Number(gsap.getProperty(cloneEl, "scaleX")) || 1;
    const startScaleY = Number(gsap.getProperty(cloneEl, "scaleY")) || 1;

    function currentSrcRect() {
      return {
        top: openSourceRectDoc.top - window.scrollY,
        left: openSourceRectDoc.left,
        width: openSourceRectDoc.width,
        height: openSourceRectDoc.height,
      };
    }

    let lastFlip = computeFlip(currentSrcRect(), dstRect);

    const cleanup = () => {
      gsap.set(lightbox, { display: "none", clearProps: "backgroundColor" });
      if (cloneEl && cloneEl.parentNode) cloneEl.parentNode.removeChild(cloneEl);
      cloneEl = null;
      lightbox.setAttribute("aria-hidden", "true");
      openSourceRectDoc = null;
      isOpen = false;
      isAnimating = false;
      // Resume the carousel that was paused on open
      if (pausedCycle && pausedCycle._imageCycleResume) pausedCycle._imageCycleResume();
      pausedCycle = null;
    };

    const state = { t: 0 };

    gsap.to(state, {
      t: 1,
      duration: CONFIG.closeDuration,
      ease: CONFIG.closeEase,
      onUpdate: () => {
        lastFlip = computeFlip(currentSrcRect(), dstRect);
        const t = state.t;
        gsap.set(cloneEl, {
          x: startX + (lastFlip.tx - startX) * t,
          y: startY + (lastFlip.ty - startY) * t,
          scaleX: startScaleX + (lastFlip.scaleX - startScaleX) * t,
          scaleY: startScaleY + (lastFlip.scaleY - startScaleY) * t,
        });
      },
      onComplete: cleanup,
    });

    gsap.to(lightbox, {
      backgroundColor: transparent,
      duration: 0.3,
      ease: "power2.in",
      delay: CONFIG.closeDuration * 0.4,
    });
  }

  function onDocumentClick(e) {
    // Article mode: every descendant <img> in a wrapper is clickable.
    const article = e.target.closest("[data-click-zoom-article]");
    if (article) {
      const img = e.target.closest("img");
      if (img && article.contains(img)) {
        e.preventDefault();
        open(img);
        return;
      }
    }
    // Explicit trigger on the <img> or a wrapper.
    const trigger = e.target.closest("[data-click-zoom]");
    if (!trigger) return;
    const img = trigger.tagName === "IMG" ? trigger : trigger.querySelector("img");
    if (!img) return;
    e.preventDefault();
    open(img);
  }

  function onOverlayClick() {
    if (CONFIG.closeOnClick) close();
  }
  function onKeyDown(e) {
    if (CONFIG.closeOnEscape && e.key === "Escape") close();
  }
  function onScroll() {
    if (!CONFIG.closeOnScroll) return;
    if (Math.abs(window.scrollY - openScrollY) < 2) return;
    close();
  }

  function attachCloseListeners() {
    lightbox.addEventListener("click", onOverlayClick);
    document.addEventListener("keydown", onKeyDown);
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function detachCloseListeners() {
    lightbox.removeEventListener("click", onOverlayClick);
    document.removeEventListener("keydown", onKeyDown);
    window.removeEventListener("scroll", onScroll);
  }

  document.addEventListener("click", onDocumentClick);
}

// Initialize Click to Zoom (Basic)
document.addEventListener("DOMContentLoaded", function () {
  initClickToZoomBasic();
});

// -------------------- Button Character Stagger --------------------
function initButtonCharacterStagger() {
  const offsetIncrement = 0.01;
  const buttons = document.querySelectorAll("[data-button-animate-chars]");

  buttons.forEach((button) => {
    const text = button.textContent;
    button.innerHTML = "";

    [...text].forEach((char, index) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.transitionDelay = `${index * offsetIncrement}s`;
      if (char === " ") span.style.whiteSpace = "pre";
      button.appendChild(span);
    });
  });
}

// Initialize Button Character Stagger
document.addEventListener("DOMContentLoaded", function () {
  initButtonCharacterStagger();
});
